import { Box } from '@mui/material'
import { css } from '@emotion/react'
import styled from '@emotion/styled'

export const Container = styled(Box)`
  ${() => css`
    display: flex;
    flex-direction: column;
    width: 100%;
    gap: 24px;
  `}
`

export const Grid = styled(Box)`
  ${() => css`
    display: flex;
    flex-direction: column;
    gap: 16px;
    width: 100%;
    padding: 0 20px;
  `}
`

export const EmptyState = styled(Box)`
  ${() => css`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 48px 24px;
    text-align: center;
    gap: 16px;
  `}
`

export const EmptyIcon = styled(Box)`
  ${({ theme }) => css`
    width: 64px;
    height: 64px;
    border-radius: 50%;
    background: ${theme.colors.border.light};
    display: flex;
    align-items: center;
    justify-content: center;
    color: ${theme.colors.gray.dark};
  `}
`

export const EmptyMessage = styled.span`
  ${({ theme }) => css`
    font-size: 16px;
    font-weight: 500;
    color: ${theme.colors.gray.dark};
  `}
`

export const ErrorState = styled(Box)`
  ${({ theme }) => css`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 48px 24px;
    text-align: center;
    gap: 16px;
    border: 1px solid ${theme.colors.error.color};
    border-radius: 10px;
    background: rgba(238, 0, 0, 0.05);
  `}
`

export const ErrorMessage = styled.span`
  ${({ theme }) => css`
    font-size: 16px;
    font-weight: 500;
    color: ${theme.colors.error};
  `}
`
